import React from "react";
import { useSelector } from "react-redux";
import AreaChart from "../../../../components/areaChart/areaChart";

const YearOverYearMembershipRevenue = () => {
  const { revenuesYearOverYearComparison, currencySymbol } = useSelector(
    (state) => state.membership.yearOverYearMembershipRevenue
  );

  return (
    <AreaChart
      chartData={revenuesYearOverYearComparison}
      width={675}
      currencySymbol={currencySymbol}
    />
  );
};

export default YearOverYearMembershipRevenue;
